<button class="action-btn" fxHide fxShow.gt-sm mat-icon-button matTooltipClass="toolbar-info-tooltip" 
  (click)="sendEmail()" matTooltip="support@youattest.com">
  <mat-icon>help_outline</mat-icon>
</button>    
